import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';

const Button = ({ children, variant = 'primary', to, onClick, className = '', type = 'button', showIcon = true }) => {
  const baseStyle = "group inline-flex items-center justify-center px-8 py-4 rounded-full font-medium transition-all duration-500 ease-out text-sm tracking-widest uppercase overflow-hidden relative";
  
  const variants = {
    primary: "bg-brand-dark text-white hover:bg-brand-accent hover:shadow-[0_10px_30px_-10px_rgba(156,17,156,0.6)] hover:-translate-y-1",
    secondary: "bg-brand-rose text-brand-dark hover:bg-brand-dark hover:text-white hover:shadow-lg hover:-translate-y-1",
    outline: "border border-brand-dark text-brand-dark hover:bg-brand-dark hover:text-white hover:shadow-lg hover:-translate-y-1",
    glass: "glass-panel text-brand-dark hover:bg-white hover:shadow-xl hover:-translate-y-1",
    darkGlass: "glass-dark text-white hover:bg-brand-accent hover:text-white hover:border-brand-accent hover:-translate-y-1"
  };

  const classes = `${baseStyle} ${variants[variant]} ${className}`;

  const content = (
    <>
      <span className="relative z-10 flex items-center gap-3">
        {children}
        {showIcon && (
          <SafeIcon name="ArrowRight" className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1.5" />
        )}
      </span>
      <div className="absolute inset-0 -translate-x-full group-hover:animate-[shimmer_1.5s_infinite] bg-gradient-to-r from-transparent via-white/20 to-transparent z-0 skew-x-12"></div>
    </>
  );

  if (to) {
    return (
      <Link to={to} className={classes} onClick={onClick}>
        {content}
      </Link>
    );
  }

  return (
    <button type={type} onClick={onClick} className={classes}>
      {content}
    </button>
  );
};

export default Button;